import { Location, ILocation, IAddress} from "./models";

export interface ILocationAggregate extends ILocation  {
    address: IAddress;
    // the following two properties do not need to be saved in the database for the submission, but do need to be tracked on the view model
    ownBuilding: boolean;
    haveLiquorSales: boolean;
}

export class LocationAggregate extends Location implements ILocationAggregate  {
    public address: IAddress;
    public ownBuilding: boolean;
    public haveLiquorSales: boolean;

    constructor(name: string) {
        super();
        this.name = name;
    }
}